module.exports = __webpack_public_path__ + "img/bg.d26b35ff.webp";